import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserType } from '../../types'

const initialState: UserType = {
  _id: '',
  avatar: '🍊',
  email: '',
  username: ''
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserType>) => {
      state._id = action.payload._id
      state.avatar = action.payload.avatar
      state.email = action.payload.email
      state.username = action.payload.username
      state.isVerified = action.payload.isVerified
      state.isAdmin = action.payload.isAdmin
    },
    updateUser: (state, action: PayloadAction<Partial<UserType>>) => {
      state = {
        ...state,
        ...action
      }
    },
    destoryUser: (state) => {
      state._id = ''
      state.avatar = '🍊'
      state.email = ''
      state.username = ''
      state.isVerified = undefined
      state.isAdmin = undefined
      window.location.reload()
    }
  }
})

export const { setUser, updateUser, destoryUser } = userSlice.actions
export default userSlice.reducer
